import { render } from "./UserFeedback.vue?vue&type=template&id=9ba04a34&scoped=true"
import script from "./UserFeedback.vue?vue&type=script&lang=js"
export * from "./UserFeedback.vue?vue&type=script&lang=js"

import "./UserFeedback.vue?vue&type=style&index=0&id=9ba04a34&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9ba04a34"

export default script